// Port of api/fuel/app/classes/insights/hindex/bias.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'bias',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var bias = []
        for (var b = 0; b <= 5; b++) bias.push({ own: 0, all: 0 })

        var ownRows = Util.query(
            'SELECT track_bias FROM hindex_track WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND track_hindex = ' + this._data.current.get_hindex()
        )

        var values = []
        for (var i = 0; i < ownRows.length; i++) {
            values.push(parseFloat(ownRows[i].track_bias))
        }

        for (var j = 0; j < values.length; j++) {
            var v = values[j]
            if (v < 150) bias[0].own++
            else if (v < 240) bias[1].own++
            else if (v < 340) bias[2].own++
            else if (v < 440) bias[3].own++
            else if (v < 590) bias[4].own++
            else bias[5].own++
        }

        if (values.length) {
            for (var k = 0; k <= 5; k++) {
                bias[k].own = Math.round(((100 / values.length) * bias[k].own) * 100) / 100
            }
        }

        var allRows = Util.query(
            'SELECT track_bias FROM hindex_track WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND track_hindex > 0'
        )

        var allValues = []
        for (var ai = 0; ai < allRows.length; ai++) {
            allValues.push(parseFloat(allRows[ai].track_bias))
        }

        for (var aj = 0; aj < allValues.length; aj++) {
            var av = allValues[aj]
            if (av < 150) bias[0].all++
            else if (av < 240) bias[1].all++
            else if (av < 340) bias[2].all++
            else if (av < 440) bias[3].all++
            else if (av < 590) bias[4].all++
            else bias[5].all++
        }

        if (allValues.length) {
            for (var ak = 0; ak <= 5; ak++) {
                bias[ak].all = Math.round(((100 / allValues.length) * bias[ak].all) * 100) / 100
            }
        }

        return {
            bias: bias
        }

    }
})
